const ModelosSitio = {
	AnamorphicBaileyClutter: 'AnamorphicBaileyClutter',
	AnamorphicChapmanRichards: 'AnamorphicChapmanRichards',
	AnamorphicFourParametersBailey: 'AnamorphicFourParametersBailey',
	AnamorphicSchumacher: 'AnamorphicSchumacher',
	AnamorphicThreeParametersBailey: 'AnamorphicThreeParametersBailey',
	BaileyClutter: 'BaileyClutter',
	ChapmanRichards: 'ChapmanRichards',
	PolymorphicBaileyClutter: 'PolymorphicBaileyClutter',
	PolymorphicChapmanRichards: 'PolymorphicChapmanRichards',
	PolymorphicFourParametersBailey: 'PolymorphicFourParametersBailey',
	PolymorphicSchumacher: 'PolymorphicSchumacher',
	PolymorphicThreeParametersBailey: 'PolymorphicThreeParametersBailey',
	Schumacher: 'Schumacher',
	ThreeParametersBaileyClutter: 'ThreeParametersBaileyClutter',
	ThreeParametersGompertz: 'ThreeParametersGompertz',
	ThreeParametersLogistic: 'ThreeParametersLogistic',
}

const ModelosPrognose = {
	AgeModel1: 'AgeModel1',
	AgeModel2: 'AgeModel2',
	AgeModel3: 'AgeModel3',
	ChapmanRichards: 'ChapmanRichards',
	ClutterBasalArea: 'ClutterBasalArea',
	Clutter: 'Clutter',
	Korf: 'Korf',
	Schumacher: 'Schumacher',
	SiteModel1: 'SiteModel1',
	SiteModel2: 'SiteModel2',
	SiteModel3: 'SiteModel3',
	SiteModel4: 'SiteModel4',
	ThreeParametersGompertz: 'ThreeParametersGompertz',
	ThreeParametersLogistic: 'ThreeParametersLogistic',
}

export { ModelosSitio, ModelosPrognose }
